import React, { FocusEvent } from "react";
import { Col, Row } from "react-bootstrap";
import { ActionHandlerFunction, AdminUserBase } from "@preveil-api";
import { CheckboxStates, CheckboxStatesTypes, DriveUIActionTypes } from "src/common";
import { Checkbox, EmptyView, Loading } from "src/components";
import { ListRow } from "..";
import _ from "lodash";

type AllProps = {
  is_loading: boolean;
  selected: string[];
  user_list: AdminUserBase[];
  handleAction: ActionHandlerFunction;
}

// Description: List view component for the cloud lock settings page
function ListViewComponent(props: AllProps) {
  const { is_loading, selected, user_list, handleAction } = props;

  // Description: Get the selected all checkbox state
  function getSelectedState(): CheckboxStatesTypes {
    let ck_state: CheckboxStatesTypes = CheckboxStates.empty;
    ck_state = !selected.length
      ? CheckboxStates.empty
      : selected.length < user_list.length
        ? CheckboxStates.indeterminate
        : CheckboxStates.checked;
    return ck_state;
  }

  // Description: Render the rows of Admin Users view
  function RenderList(_list: AdminUserBase[]) {
    return (
      <div className="list-body">
        {_.map(_list, (user: AdminUserBase, i: number) => {
          return (
            <ListRow
              key={`item_${i}`}
              user={user}
              handleAction={handleAction}
              selected={selected.includes(user.user_id)}
            />
          );
        })}
      </div>
    );
  }

  return <div className={`admin-list-view cloud-lock ${is_loading ? " isloading" : ""}`}>
    {!!user_list && user_list.length > 0 && (
      <Row className="header-row">
        <Col md="1">
          <Checkbox
            className="sr-only"
            onChange={(e: FocusEvent<HTMLInputElement>) => {
              handleAction({
                actionType: DriveUIActionTypes.Select,
                params: { selected: e.target.checked },
              });
            }}
            value="all"
            label="Select All"
            selected={getSelectedState()}
          />
        </Col>
        <Col sm={4} className="col">Name</Col>
        <Col sm={3} className="ps-1">Email</Col>
        <Col sm={3}>Role</Col>
      </Row>
    )}
    {!!user_list && user_list.length > 0 ? (
      RenderList(user_list)
    ) : !is_loading ? <EmptyView message="No matches found!" /> : null}

    {is_loading && <Loading />}
  </div>;
}

export default React.memo(ListViewComponent);